const CouplerStyleTypes = Object.freeze({
  Other: 'Other',
  OilQuick: 'OilQuick',
  Symmetrical: 'Symmetrical',
  MultiPinGrab: 'Multi Pin Grab',
  Dedicated: 'Dedicated',
  RotoTilt: 'Rototilt',
  SteelWrist: 'Steelwrist',
  EngCon: 'Engcon',
  CatHcs: 'CAT HCS'
});

export { CouplerStyleTypes };
